import React, { useState, useEffect, useCallback } from 'react';
import { Table, FormControl, Container, Button } from 'react-bootstrap';
import { productosGet } from '../../../services/productos';
import { useNavigate } from 'react-router-dom';

function GridProductos(props) {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();


  const handleChange = useCallback((e) => {
    setSearchTerm(e.target.value);
    console.log(e.target.value);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await productosGet(searchTerm);
        console.log(response);
        setData(response);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [searchTerm, handleChange]);

  const filteredData = data.filter((item) => {
    return item.name.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase())
  }
  );

  const handleEdit = (id) => {
    console.log(`Editar el id : ${id}`);
    navigate(`../updateProductos/${id}`);
  }

  return (
    <Container>
      <FormControl
        type="text"
        placeholder="Busca por nombre"
        className="mb-3"
        value={searchTerm}
        onChange={handleChange}
      />
      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th></th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Categoria</th>
            <th>Color</th>
            <th>Material</th>
            <th>Tamaño</th>
            <th>Precio unitario</th>
            <th>Descuento</th>
            <th>Cantidad</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.description}</td>
              <td>{item.id_Basic_Products}</td>
              <td>{item.colors}</td>
              <td>{item.fabrics}</td>
              <td>{item.size}</td>
              <td>MXN $ {Number(item.unit_Price).toFixed(2)}</td>
              <td>{((item.discount > 0) ? "- MXN $ " + Number(item.discount).toFixed(2) : "")}</td>
              <td>{item.quantity} Unidad(es)</td>
              <td>
                <Button
                  variant="warning"
                  onClick={() => handleEdit(item.id)}
                >
                  Modificar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default GridProductos;